Vendd.Scripts.load(function () {
 
    if ($('.header-template-one').length <= 0)
        return;

    stickyHeader();  

    if ($('.productDetails-template').length > 0) {
        $('.js-header-buy-now').on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();

            var $addToOrderBtn = $('.js-add-to-order.primary-add-to-order');

            if ($addToOrderBtn.length > 0) {
                if ($addToOrderBtn.hasClass('disabled')) {
                    $('html, body').animate({ scrollTop: $('.pd-box-three').offset().top - 100 }, 400);    
                } else {
                    $addToOrderBtn.trigger('click');
                }
            }
        });
    }
});

function stickyHeader() {

    var header = $('.header-region');
    var headerHeight = header.outerHeight();
    var menuHeight = $('.region-area-two', header).outerHeight();
    var eSatisfactionHeight;
    var criticalHeight;

    var spacer = $('.header-spacer');

    var didScroll;
    var lastScrollTop = 0;
    var delta = 5;

    $(window).scroll(initSticky);

    function initSticky() {

        //if ($(window).outerWidth() < 1200)
        //    return;

        var st = $(this).scrollTop();
        // Make sure they scroll more than delta
        if (Math.abs(lastScrollTop - st) <= delta)
            return;

        // If they scrolled down and are past the navbar, add class .nav-up.
        // This is necessary so you never see what is "behind" the navbar.
        /*
        if (st > lastScrollTop && st > headerHeight + headerPrevHeight) {
            // Scroll Down
            header.addClass('hidden');
        } else {
            // Scroll Up
            if (st + $(window).height() < $(document).height()) {
                header.removeClass('hidden');
            }
        }
        */

        eSatisfactionHeight = $('.esat-bar').height() || 0;
        criticalHeight = (headerHeight + eSatisfactionHeight) - menuHeight;

        if ($(window).scrollTop() < criticalHeight) {
            header.removeClass('sticky');
            spacer.height(0);
        } else {
            header.addClass('sticky');
            spacer.height(headerHeight);
        }
        lastScrollTop = st;
    }
    
}

function menuEffect() {
    // Hide header on on scroll down

    var header = $('.header-region');
    var headerHeight = header.height();

    var didScroll;
    var lastScrollTop = 0;
    var delta = 5;

    setInterval(function () {
        if (didScroll) {
            var st = $(this).scrollTop();
            // Make sure they scroll more than delta
            if (Math.abs(lastScrollTop - st) <= delta)
                return;

            // If they scrolled down and are past the navbar, add class .nav-up.
            // This is necessary so you never see what is "behind" the navbar.
            if (st > lastScrollTop && st > headerHeight) {
                // Scroll Down
                header.addClass('hidden');
            } else {
                // Scroll Up
                if (st + $(window).height() < $(document).height()) {
                    header.removeClass('hidden');
                }
            }

            lastScrollTop = st;
            didScroll = false;
        }
    }, 250);

}

function calculateSearchHeight() {
    var $wrapper = $('.x-searchbox.elastic');

    if ($wrapper.length < 1 || $(window).outerWidth() < 960) return;

    var header = $('.header-region');
    var headerHeight, regionHeight, eSatisfactionHeight, searchOffset;

    //header height
    headerHeight = header.height() || 0;
    regionHeight = $('.region-area-two', header).height() || 0;
    headerHeight = headerHeight - regionHeight;
    //esatisfaction height
    eSatisfactionHeight = $('.esat-bar').height() || 0;
    //search offset
    searchOffset = headerHeight + eSatisfactionHeight;
    
    $('.x-elastic-results-list', $wrapper).css({ 'height': 'calc(100% - ' + searchOffset + 'px)', top: searchOffset });
}